import React from "react";
import { connect } from "react-redux";
import { Button, TextBox } from "devextreme-react";
import moment from "moment";
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import helper from "../../../../../helpers/validaciones";
import Modal from "./modal";
import UserInfo from "./userInfo";
import LoadingOverLay from "../../../../Shared/LoadingOverlay";
import {
  doSendNewSolicitud,
  doDeleteSolicitud,
  doResendSolicitud,
  doGetSolicitudes,
  setErrorCompanyRut,
  getRolesPortalEmpresa,
  getRolesFromUserAndCompany
} from "./actions";
import { SelectBox } from 'devextreme-react/ui/select-box';
import Select from './Select'
import constants from '../../../../../helpers/constants';
import { openCloseToast } from '../../../../Global/actions'
import { getRolesByProfileId } from "../../../Empresa/GestionUsuarios/AsignacionRoles/actions";
import { getRoles } from "../../../Mantenedores/General/actions";


const ActionButton = (props) => (
  <Button
    type={props.type}
    disabled={props.disabled}
    text={props.text}
    onClick={props.onClick}
    style={props.style}
    render={(btn) => (
      <div
        style={{
          padding: "7px 0px 0px 0px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {btn.text}
      </div>
    )}
  />
);

class SolicitudesPendientes extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      modalTitle: "",
      modalType: null,
      modalHeight: null,
      rutEmpresa: "",
      isValidRut: false,
      isValidDesc: false,
      modalLastPage: false,
      modalAcceptCallback: null,
      modalDisableNext: false,
      role: 'PER_TRABAJADOR',
      permit: [],
      currentRoles: [],
      acceptText: null
    };
    this.tableRef = React.createRef();
    this.timeout = 0;
    props.dispatch(doGetSolicitudes(props.UserInfo.RUT));
    props.dispatch(getRolesPortalEmpresa());
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyRutError == null && this.props.companyRutError === false) {
      this.handleFinalStep();
    }
    if (prevProps.companyRutError == null && this.props.companyRutError !== null && this.props.companyRutError.length > 0) {
      this.handleAddModal();
    }
    if (!this.props.roles && this.props.perfiles.length) {
      const perfilEmpresa = this.props.perfiles.find((p) => p.Code === constants.codePerfilEmpresa);
      this.props.dispatch(getRoles());
      if (perfilEmpresa) {
        this.props.dispatch(getRolesByProfileId(perfilEmpresa.Id));
      }
    }
  }

  handleCloseModal = () => {
    this.props.dispatch(setErrorCompanyRut(null));
    this.setState({
      showModal: false,
      modalHeight: null,
      rutEmpresa: "",
      isValidDesc: false,
      modalDisableNext: false,
      modalAcceptCallback: null,
      // role: 'PER_TRABAJADOR',
      permit: [],
      isValidRut: false,
      // acceptText: null,
    });
  }

  handleChange = (e) => {
    const ident = (typeof e === "object") ? e.element.id : "";
    let {
      isValidDesc,
      isValidRut,
      rutEmpresa,
      role,
      permit
    } = this.state;

    if (ident === 'rutEmpresa') {
      if (helper.validateRut(e.value)) {
        rutEmpresa = helper.formatRut(e.value, { showDots: true, showHyphen: true });
        isValidRut = true;
        e.component.option({
          validationError: { message: "" },
          isValid: isValidRut,
        });

        this.props.dispatch(getRolesFromUserAndCompany(e.value, this.props.UserInfo.RUT))
        // role = 'PER_TRABAJADOR';
        permit = [];
      } else if (e.value === "") {
        isValidRut = false;
        rutEmpresa = e.value
        e.component.option({
          validationError: { message: "" },
          isValid: true,
        });
      } else {
        rutEmpresa = e.value;
        isValidRut = false;

        e.component.option({
          validationError: { message: "Formato de rut inválido" },
          isValid: isValidRut,
        });
      }
    } else if (ident === 'role') {
      role = e.value
      permit = []
    } else if (ident === 'workerPermits' || ident === 'enterprisePermits') {
      permit = e.value
    }

    this.setState({
      isValidRut,
      isValidDesc,
      rutEmpresa,
      modalDisableNext: !(isValidRut && role && (Array.isArray(permit) ? permit.length : permit)),
      role,
      permit
    });
  }

  handleRoles = (e) => {
    this.setState({
      ...this.state,
      permit: e.value,
      modalDisableNext: !(this.state.isValidRut && this.state.role && (Array.isArray(e.value) ? e.value.length : e.value)),
    })
  }

  handleAddModal = () => {
    this.setState({
      showModal: true,
      modalTitle: "Nueva solicitud",
      modalHeight: 450,
      modalType: null,
      modalDisableNext: true,
      modalLastPage: false,
      modalAcceptCallback: this.handleAddStep2,
      // role: 'PER_TRABAJADOR',
      permit: [],
      isValidRut: false,
      rutEmpresa: '',
      acceptText: "Enviar",
    });
  }

  handleAddStep2 = () => {
    const rutEmpresa = helper.formatRut(this.state.rutEmpresa, { showDots: false, showHyphen: true });
    const userInfo = this.props.UserInfo;
    if (!userInfo.TempBD && this.props.listaEmpresas) {
      // const alreadyInCompany = this.props.listaEmpresas.find((c) => c.RutEmpresa === rutEmpresa);
      // if (alreadyInCompany) {
      //   this.props.dispatch(setErrorCompanyRut(`Usted ya es parte de la empresa de rut ${rutEmpresa}.`));
      //   return;
      // }
    } else {
      const inCompany = this.props.solicitudes.find((c) => c.CompanyRut === rutEmpresa);
      if (inCompany) {
        this.props.dispatch(setErrorCompanyRut(`Usted ya es parte de la empresa de rut ${rutEmpresa}.`));
        return;
      }
    }
    this.props.dispatch(
      doSendNewSolicitud({
        rutEmpresa,
        userInfo,
        role: this.state.role,
        permits: this.state.permit
      }));
  }

  handleFinalStep = () => {
    this.setState({
      showModal: false,
      modalHeight: null,
      rutEmpresa: "",
      isValidDesc: false,
      modalDisableNext: false,
      modalAcceptCallback: null,
      // role: null,
      permit: null
    });

    const toast = {}
    toast.isToastOpen = true;
    toast.msgToast = "Tu solicitud ha sido enviada con éxito al administrador. Notificaremos la resolución a tu correo electrónico.";
    toast.typeStyle = "success";
    toast.displayTime = 5000
    this.props.dispatch(openCloseToast(toast));
  }

  handleDeleteModal = (data, rutEmpresa) => {
    const userRut = this.props.UserInfo.RUT;
    this.setState({
      rutEmpresa,
      showModal: true,
      modalTitle: "Eliminar solicitud",
      modalType: "del",
      modalLastPage: false,
      acceptText: "Eliminar",
      modalAcceptCallback: () => {
        this.props.dispatch(doDeleteSolicitud(userRut, data.ID, data.FromUser));
        this.handleCloseModal();
      },
    });
  }

  handleResendModal = (IdSolicitud, rutEmpresa, fromUser) => {
    this.setState({
      showModal: true,
      rutEmpresa,
      modalLastPage: false,
      modalType: null,
      modalTitle: "Reenviar solicitud",
      acceptText: "Reenviar",
      modalAcceptCallback: () => {
        this.props.dispatch(doResendSolicitud(IdSolicitud, fromUser));
        this.handleCloseModal();
      },
    });
  }

  handleBuscarSolcitud = (e) => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.tableRef.searchByText(e.value);
    }, 300);
  }

  renderWorkerItems = item => (
    <p className='select-item-muted'>
      <strong>{item.Name}</strong>: {item.Description}
    </p>
  )

  render() {
    let body;
    switch (this.state.modalTitle) {
      case "Reenviar solicitud":
        body = (
          <div style={{ marginTop: 19 }}>
            {`¿Desea reenviar la solicitud al administrador de la empresa ${this.state.rutEmpresa}?`}
          </div>
        );
        break;

      case "Eliminar solicitud":
        body = (
          <div style={{ marginTop: 19 }}>
            {`¿Estás seguro que quieres eliminar la solicitud enviada a la empresa ${this.state.rutEmpresa}?`}
          </div>
        );
        break;

      case "Nueva solicitud":
        body = (
          <div className="row zero" style={{ margin: -10, justifyContent: "center" }}>
            {this.props.isLoading && <LoadingOverLay style={{ height: 275 }} />}
            <span className='modal-subtitle mb-4'>Ingresa los campos solicitados para enviar la solicitud</span>
            <div className="col-10">
              <div style={{ position: "absolute", left: 20, right: 20, marginTop: -10 }}>
                <h3><p className="text-left success">RUT Empresa</p></h3>
                <TextBox
                  id="rutEmpresa"
                  placeholder="Rut empresa"
                  onValueChanged={this.handleChange}
                  value={this.state.rutEmpresa}
                  valueChangeEvent="focusout"
                  maxLength={16}
                />
                <div className='text-left text-danger'>
                  {((!this.state.isValidRut && this.state.rutEmpresa) || this.props.companyRutError) && (
                    <span>
                      {
                      this.state.rutEmpresa === "" && this.props.companyRutError
                      ? this.props.companyRutError
                      : !this.state.isValidRut
                        ? '* Rut empresa no válido'
                        : this.props.companyRutError &&
                          this.props.companyRutError.split(" ") &&
                          this.props.companyRutError.split(" ")[4] &&
                          helper.formatRut(this.props.companyRutError.split(" ")[4], { showDots: true, showHyphen: true }) === this.state.rutEmpresa
                          ? this.props.companyRutError
                          : null
                      }
                    </span>
                  )}
                </div>
                <h3><p className={`text-left ${this.state.isValidRut ? 'success' : 'text-disabled'}`}>Tipo de Rol</p></h3>
                <SelectBox
                  id="role"
                  // items={constants.roleTypes.filter(r => r.Code !== 'PER_SEL')}
                  items={constants.roleTypes}
                  placeholder='Seleccione'
                  onValueChanged={this.handleChange}
                  disabled={!this.state.isValidRut}
                  defaultValue={this.state.role}
                  displayExpr="Name"
                  valueExpr="Code"
                />
                <h3><p className={`text-left ${this.state.isValidRut ? 'success' : 'text-disabled'}`}>Permisos</p></h3>
                {this.state.role === 'PER_TRABAJADOR' && (
                  <SelectBox
                    id='workerPermits'
                    placeholder='Permisos'
                    onValueChanged={this.handleChange}
                    disabled={!this.state.isValidRut}
                    defaultValue={this.state.role}
                    displayExpr='Name'
                    valueExpr='Id'
                    dataSource={constants.workerPermits}
                    dataSource={constants.workerPermits.map(r => ({
                      ...r,
                      disabled: !!this.props.currentRoles.find(c => c === r.Id)
                    }))}
                    itemRender={this.renderWorkerItems}
                  />
                )}
                {this.state.role === 'PER_EMPRESA' && (
                  <Select
                    title='enterprisePermits'
                    selectedItems={this.state.permit || []}
                    dataSource={this.props.roles.map(r => ({
                      ...r,
                      disabled: !!this.props.currentRoles.find(c => c === r.Id)
                    }))}
                    onSelection={this.handleRoles}
                    openClose={isOpen => this.setState({...this.state, openSelectRoles: isOpen})}
                    open={this.state.openSelectRoles}
                    disabled={!this.state.isValidRut}
                  />
                )}
              </div>
            </div>
          </div>
        );
        break;

      default:
        body = <div></div>;
    }

    return (
      <div>
        <Modal
          title={this.state.modalTitle}
          height={this.state.modalHeight}
          type={this.state.modalType}
          body={body}
          isLastPage={this.state.modalLastPage}
          open={this.state.showModal}
          handleSuccess={this.state.modalAcceptCallback}
          onClose={this.handleCloseModal}
          disableNext={this.state.modalDisableNext}
          acceptText={this.state.acceptText}
          handleRechazo={this.handleCloseModal}
          showCancel
          width={"772px"}
        />

        {this.props.UserInfo.TempBD && <UserInfo info={this.props.UserInfo} />}

        {this.props.solicitudes && this.props.solicitudes.length ? (
          <React.Fragment>
            {this.props.isLoading && !this.state.showModal && <LoadingOverLay />}
            <div style={{ display: "flex", flexDirection: "row", marginBottom: 10 }}>
              <TextBox
                placeholder="Buscar empresa"
                onValueChanged={this.handleBuscarSolcitud}
                mode="search"
                style={{ flexGrow: 1, marginRight: 10 }}
                valueChangeEvent="keyup"
              />
              <Button
                text="Enviar nueva solicitud"
                type="success"
                onClick={this.handleAddModal}
              />

            </div>
            <DataGrid
              showBorders={false}
              showColumnLines={false}
              showRowLines={false}
              className="custom-table"
              noDataText="Sin solicitudes"
              ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
              rowAlternationEnabled
              style={{ marginTop: 10 }}
              loadPanel={{
                enabled: false,
              }}
              paging={{ pageSize: 10 }}
              pager={{
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20],
                showInfo: true,
              }}
              dataSource={this.props.solicitudes}
            >
              <Column
                dataField="CompanyRut"
                caption="Rut empresa"
                allowSearch
              />
              <Column
                alignment='right'
                cellComponent={(e) =>
                  (<div style={{display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "flex-end"}}>
                  <ActionButton
                    text="Reenviar"
                    disabled={moment().diff(e.data.LastReminderDate, "days") === 0}
                    type="success"
                    className="slimButton"
                    style={{marginRight: "8px"}}
                    onClick={() => this.handleResendModal(e.data.ID, e.data.CompanyRut, e.data.FromUser)}
                  />
                  <ActionButton
                    text="Eliminar"
                    type="danger"
                    className="slimButton"
                    onClick={() => this.handleDeleteModal(e.data, e.data.CompanyRut)}
                  />
                  </div>)
                }
              />
              {/* <Column
                cellComponent={(e) =>
                  ()
                }
              /> */}
            </DataGrid>

          </React.Fragment>
        )
          :
          (
            <div className="row">
              <div className="col-12 text-left list-with-button">
                <div className="contenedor dx-form-group-with-caption dx-form-group dx-group-colcount-2">
                  <div className="col-12 zero">
                    <h5>
                    Podrás solicitar un rol a la(s) empresa(s) que estime conveniente.
                    </h5>
                  </div>
                  <Button
                    className="list-button"
                    text="Nueva solicitud"
                    type="success"
                    onClick={this.handleAddModal}
                  />
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.solicitudes.isLoading,
    UserInfo: state.global.userData,
    solicitudes: state.solicitudes.solicitudes,
    companyRutError: state.solicitudes.companyRutError,
    listaEmpresas: state.global.listaEmpresas,
    // roles: state.solicitudes.rolesPortalEmpresa,
    roles: state.asignacionRoles.roles,
    currentRoles: state.solicitudes.rolesCurrentUser,
    perfiles: state.mantenedores.perfiles,
  }
};

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesPendientes);
